import React, { forwardRef } from 'react'
import { useTranslation } from 'i18n'
import './ProgressBar.scss'

const ProgressBar = forwardRef(({
  label = '',
  showDots = true,
  showNumber = true,
  position,
  total,
  isEditorialWithoutImage,
  // Optional style overrides — all default to undefined so non-puck callers are unaffected.
  activeColor,
  inactiveColor,
  inactiveOpacity,
  dotSize,
  outlined = false,
  subtleShadow = true,
  labelStyle,
  numberStyle,
}, ref) => {
  const { t } = useTranslation()
  const dotBaseStyle = dotSize
    ? { width: dotSize, height: dotSize, borderRadius: '50%' }
    : null

  const buildLiStyle = (isActive) => {
    const s = {}
    if (dotBaseStyle) Object.assign(s, dotBaseStyle)
    if (outlined) {
      s.backgroundColor = 'transparent'
      const color = isActive ? activeColor : inactiveColor
      if (color) s.border = `1px solid ${color}`
    } else {
      const color = isActive ? activeColor : inactiveColor
      if (color) s.backgroundColor = color
    }
    if (!isActive && typeof inactiveOpacity === 'number') {
      s.opacity = inactiveOpacity
    }
    return Object.keys(s).length ? s : undefined
  }

  return (
    <div
      className={`progress-bar${subtleShadow ? ' subtle-shadow' : ''}`}
      ref={ref}
      tabIndex={0}
    >
      {label && (
        <span className="progress-bar-text" style={labelStyle}>
          {label}
        </span>
      )}
      {showNumber && (
        <span className="progress-bar-number" style={numberStyle}>
          {t('counter', { current: position, total })}
        </span>
      )}
      {showDots && (
        <ul className="progress-bar-dots">
          {Array.from({ length: total }).map((_, i) => {
            const isActive = i + 1 === position
            return (
              <li
                key={i}
                className={isActive ? 'active' : ''}
                style={buildLiStyle(isActive)}
              />
            )
          })}
        </ul>
      )}
    </div>
  )
})

ProgressBar.displayName = 'ProgressBar'

export default ProgressBar
